import { useMemo } from "react";
import { useProductsQuery } from "web_myplann/Api/Portfolio/Queries/useProductsQuery";
import type {
	ClientPortfolioDomainEnum,
	ProductResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

type ProductOptions = {
	options: FlatRowSelectOption<string>[];
	isLoading: boolean;
};

export const mapProductsToOptions = (
	products: ProductResponseDTO[],
): FlatRowSelectOption<string>[] =>
	products.map((product) => ({
		value: product.name,
		label: product.name,
	}));

export const useProductOptions = (
	domain: ClientPortfolioDomainEnum,
	producerId: number | undefined,
): ProductOptions => {
	const { data, isFetching } = useProductsQuery(domain, producerId);

	const options = useMemo(() => mapProductsToOptions(data?.data ?? []), [data]);

	return { options, isLoading: isFetching };
};
